<template>
    <div class="inPage">
        <div class="noPageBox">
            <div class="wrapper">
                <div class="noPage">
                    <div class="left">
                        <div class="title">
                            HUH!<br>
                            THE PAGE IS MISSING!!
                        </div>
                        <div class="desc">
                            The possible reasons are: <br>
                            The site may be under maintenance or there may<br>
                            be a procedural issue
                        </div>
                        <div class="button">
                            <router-link to="/">Home</router-link>
                        </div>
                    </div>
                    <div class="right">
                        <img src="./404.jpg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data(){
        return{
            isZhong:false,
            
        }
    },
    
}
</script>

<style lang="scss" scoped>
.noPageBox{
    padding:116px 0 66px 0;
    .noPage{
        width: 100%;
        min-height: 498px;
        display: flex;
        justify-content: center;
        align-items: center;
        .title{
            font-size: 32px;
            line-height: 56px;
            font-weight: bold;
        }
        .desc{
            font-size: 14px;
            line-height: 28px;
            margin-top: 22px;
        }
        .button{
            margin-top: 22px;
            a{
                display: block;
                width: 168px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                background: #0d69af;
                color: #fff;
                font-size: 18px;
                font-weight: bold;
                border-radius: 6px;
            }
            
        }
    }

}

</style>


// WEBPACK FOOTER //
// src/pages/NoPage/NoPage.vue